import { render, staticRenderFns } from "./brand-item-settings.vue?vue&type=template&id=e42fe1b4&"
import script from "./brand-item-settings.vue?vue&type=script&lang=js&"
export * from "./brand-item-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports